import React from 'react'
import { styled } from 'styled-components'
import { QuestionSlot, OptionalMarkdown } from '@mission.io/question-views'
import {
	PlayerWrapper,
	StudentsQuestionDisplay,
	MarkdownHeader,
} from './sharedComponents'
import {
	useQuestionSlotQuestion,
	getStudentsToShowForQuestionSlot,
	useJuniorStateSelector,
} from '../../../context'
import { cssPlayerHeightUnit } from '../../../utility/constants'
import { TIMER_HEIGHT } from '../../frames/MissionFrame/TimerAnimations'
import { variantTypes, type ClientQuestion } from '@mission.io/question-toolkit'
import { PERCENTAGE_OF_SCREEN_WIDTH_TAKEN_BY_TOP_CORNERS } from '../../frames/MissionFrame/TopFrame.jsx'
import { MissionFrameFooterSpacer } from './sharedComponents.jsx'
import { useMissionStateSelector } from '../../../context/customHooks'
import { getScreenTimerForNotifications } from '../../../context/missionState/video'
import { useTimer } from '../../../context/timers'

export default function QuestionSlotScreen(): React$Node {
	const question = useQuestionSlotQuestion()

	const studentsToShow = useJuniorStateSelector(
		getStudentsToShowForQuestionSlot
	)
	const timerId = useMissionStateSelector(getScreenTimerForNotifications)
	const timer = useTimer(timerId)
	const [everWasATimer, setEverWasATimer] = React.useState()
	React.useEffect(() => {
		if (timer) {
			setEverWasATimer(true)
		}
	}, [timer])

	if (!question) {
		return null
	}

	return (
		<StyledPlayerWrapper className="[&>*]:font-game-body">
			<MarkdownHeader
				style={{
					paddingTop: everWasATimer ? `${TIMER_HEIGHT}px` : '24px',
					paddingBottom: '8px',
					paddingLeft: PERCENTAGE_OF_SCREEN_WIDTH_TAKEN_BY_TOP_CORNERS + '%',
					paddingRight: PERCENTAGE_OF_SCREEN_WIDTH_TAKEN_BY_TOP_CORNERS + '%',
				}}>
				<OptionalMarkdown className="prose-invert !text-2xl [&_*_p]:!mt-2 [&_*_p]:!mb-2">
					{getHeaderText(question)}
				</OptionalMarkdown>
			</MarkdownHeader>
			<Centered>
				{question.type === variantTypes.FREE_RESPONSE ? (
					<LargerFont>
						{studentsToShow.length > 0 ? (
							<StudentsQuestionDisplay
								students={studentsToShow.map(student => {
									return { ...student, submitted: Boolean(student.response) }
								})}
							/>
						) : (
							<div className="font-game-headline">No Connected Students</div>
						)}
					</LargerFont>
				) : (
					<QuestionSlotWrapper>
						<QuestionSlot question={question} />
					</QuestionSlotWrapper>
				)}
			</Centered>
			<MissionFrameFooterSpacer />
		</StyledPlayerWrapper>
	)
}

const getHeaderText = (question: ClientQuestion): string => {
	if (question.type === variantTypes.CLOZE_DROPDOWN) {
		return 'Please select the correct options for the phrase below'
	}
	return question.phrase
}

const LargerFont = styled.div`
	${({ theme }) => `
	font-size: max(${theme.fontl}, ${cssPlayerHeightUnit(2)});`}
`

const Centered = styled.div`
	display: flex;
	margin-top: 8px;
	flex: 1;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	overflow: hidden;
`
const StyledPlayerWrapper = styled(PlayerWrapper)`
	display: flex;
	flex-direction: column;
`

const QuestionSlotWrapper = styled.div`
	width: 90%;
	height: 100%;
`
